export default function Hero() {
  return (
    <section className="relative h-[200px] w-full overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=Serene%20botanical%20nursery%20scene%20with%20rows%20of%20lush%20green%20potted%20plants%20and%20delicate%20flowering%20perennials%2C%20soft%20warm%20morning%20sunlight%20streaming%20through%20a%20glass%20greenhouse%20roof%2C%20peaceful%20garden%20pathway%20with%20natural%20stone%20texture%2C%20gentle%20depth%20of%20field%2C%20professional%20editorial%20garden%20photography%20with%20warm%20natural%20tones%20and%20organic%20composition&width=1920&height=1080&seq=contact-hero-bg&orientation=landscape"
          alt="Serene botanical garden with potted plants"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative h-full max-w-7xl mx-auto px-4 md:px-6 lg:px-8 flex items-center justify-center">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-white tracking-tight">
          Contact
        </h1>
      </div>
    </section>
  );
}